// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__jlF-H","toggleInput":"Toggle_toggleInput__BjbO-","slider":"Toggle_slider__CaBI0"};